'use client';

import React from 'react';
import { cn } from '@/utils';
import { Icon } from '@/components/Icons/Icon';

export interface OfflineBannerProps {
  isSmUp: boolean;
}

/**
 * Banner shown whenever the browser reports no network connectivity. While
 * offline the session parks in a reconnecting state (without burning the retry
 * budget) and resumes automatically when the connection returns. Sits below the
 * avatar window on desktop; fixed near the bottom on mobile (where the avatar
 * window is full-screen).
 */
export const OfflineBanner: React.FC<OfflineBannerProps> = ({ isSmUp }) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      'mx-auto flex max-w-[629px] items-start gap-2 rounded-lg border border-accent-border-red bg-accent-surface-red px-4 py-3 text-left',
      {
        'fixed bottom-4 left-1/2 z-30 w-[calc(100%-1.5rem)] -translate-x-1/2': !isSmUp,
      },
    )}
  >
    <Icon name="WarningDiamond" size={20} className="mt-0.5 shrink-0 text-accent-status-red" />
    <p className="font-text text-body font-bold text-neutral-gray-700">
      You&apos;re offline. We&apos;ll reconnect automatically when your connection returns.
    </p>
  </div>
);
